import { emissionsFilterConfig } from '../miscellaneous-components/custom-filter-config';
import { IWidgetFilters } from '../../../shared/services/dashboard/dashboard.model';

// The subset of emission-filter dimensions the widget-data endpoint understands. (Vehicle,
// manufacturer, measurement unit, emission factor, custom field and FLAG are out of scope for
// widget filtering in phase 1.)
const DASHBOARD_FILTER_MODELS = [
  'scope', 'group', 'category', 'dataType', 'location', 'country', 'subsidiary', 'project', 'contactSupplier',
];

// Reuses the emissions filter picker's config, narrowed to the supported dimensions, so per-widget
// filtering looks and behaves exactly like the emissions list filter.
//
// Category Group is added here and not to the emissions list's own config: the widget-data endpoint
// understands it (it expands a group into its categories), the emissions list endpoint does not, and
// a filter the list silently ignored would be worse than no filter. It sits right after Category.
const baseWidgetFilterConfig = emissionsFilterConfig.filter(
  (c) => c.model !== null && DASHBOARD_FILTER_MODELS.includes(c.model),
);
const categoryIndex = baseWidgetFilterConfig.findIndex((c) => c.model === 'category');
export const dashboardWidgetFilterConfig = [
  ...baseWidgetFilterConfig.slice(0, categoryIndex + 1),
  { name: 'Category Group', model: 'categoryGroup', inputType: 'multiSelect' as const },
  ...baseWidgetFilterConfig.slice(categoryIndex + 1),
];

// CustomFilter keys its values by `model`; the widget-data endpoint speaks the analytic-report
// filter shape (filterByX boolean + id array). This is the single mapping between the two.
const MODEL_TO_FILTER: Record<string, [string, string]> = {
  scope: ['filterByScope', 'scopes'],
  group: ['filterByGroup', 'groups'],
  category: ['filterByCategory', 'categories'],
  categoryGroup: ['filterByCategoryGroup', 'categoryGroups'],
  dataType: ['filterByDataType', 'dataTypes'],
  location: ['filterByLocation', 'locations'],
  country: ['filterByCountry', 'countries'],
  subsidiary: ['filterBySubsidiary', 'subsidiaries'],
  project: ['filterByProject', 'projects'],
  contactSupplier: ['filterBySupplier', 'suppliers'],
};

export function filterValuesToWidgetFilters(values: Record<string, any>): IWidgetFilters {
  const filters: any = {};
  for (const model of Object.keys(MODEL_TO_FILTER)) {
    const [flag, listKey] = MODEL_TO_FILTER[model];
    const value = values?.[model];
    if (Array.isArray(value) && value.length > 0) {
      filters[flag] = true;
      filters[listKey] = value;
    }
  }
  return filters;
}

export function widgetFiltersToFilterValues(filters?: IWidgetFilters): Record<string, any> {
  const values: Record<string, any> = {};
  if (!filters) return values;
  for (const model of Object.keys(MODEL_TO_FILTER)) {
    const [flag, listKey] = MODEL_TO_FILTER[model];
    if ((filters as any)[flag] && Array.isArray((filters as any)[listKey])) {
      values[model] = (filters as any)[listKey];
    }
  }
  return values;
}

export function activeFilterCount(filters?: IWidgetFilters): number {
  if (!filters) return 0;
  return Object.keys(MODEL_TO_FILTER).filter((model) => (filters as any)[MODEL_TO_FILTER[model][0]]).length;
}
